import { ApiEnums } from '../../constants/apiConstants';
import { httpMgr } from '../network/httpMgr';
import { storageMgr } from '../storageMgr';

const PAYAPIHOST = 'https://api.hellobike.com/api';

/**
 * request
 * @param { apiurl, body, isNeedLogin是否需要登陆, isSkipLogin 需要token登录接口是否去登录页面 }
 */

/**
 * 微信分享签名
 * @param params url: string
 */
export function getWeixinSign(url: string) {
  return httpMgr.request(ApiEnums.GET_WEIXINSIGN, { url });
}

/**
 * 获取微信授权用户的openid
 * @param 微信用户授权后的code
 */
export function getWeixinOpenId(code: string, scope = '') {
  const storageKey = `${scope}wx_open_id_`;
  return httpMgr.request(ApiEnums.GET_OPENID, { code, baseURL: PAYAPIHOST }).then((response) => {
    const responseData = response;
    const wxOpenId = responseData.data.openid;
    if (wxOpenId) {
      storageMgr.setItem(storageKey, wxOpenId);
      return wxOpenId;
    }
    throw new Error('获取openId失败');
  });
}

// export function validateOpenId(params: any) {
//   alert('validparams'+params)
//   return httpMgr.request(ApiEnums.GET_VALIDATEOPENID, params).then(res => res === 1)
// }
